import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import InvestigationDrawer from "security-app/components/Investigations/Drawer";
import { singleton } from "logic/singleton";
import useFeature from "hooks/useFeature";
const InvestigationDrawerContext = createContext(null);
export function InvestigationDrawerProvider({ children }) {
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const getCurrentInvestigationId = useCallback(() => {
    var _a;
    try {
      return (_a = localStorage.getItem("currentInvestigationId")) != null ? _a : void 0;
    } catch {
      return void 0;
    }
  }, []);
  const initialId = getCurrentInvestigationId();
  const [showDrawer, setShowDrawer] = useState(!!initialId);
  const [collapsed, setCollapsed] = useState(!!initialId);
  const [fullScreen, setFullScreen] = useState(false);
  const [selectedInvestigationId, setSelectedInvestigationId] = useState(initialId);
  const updateInvestigationId = useCallback((investigationId) => {
    if (!investigationId) return;
    setSelectedInvestigationId(investigationId);
    try {
      localStorage.setItem("currentInvestigationId", investigationId);
    } catch {
    }
  }, []);
  const clearInvestigation = useCallback(() => {
    setSelectedInvestigationId(void 0);
    setShowDrawer(false);
    setCollapsed(true);
    setFullScreen(false);
    try {
      localStorage.removeItem("currentInvestigationId");
    } catch {
    }
  }, []);
  const contextValue = useMemo(
    () => ({
      collapsed,
      setCollapsed,
      setShowDrawer,
      fullScreen,
      setFullScreen,
      clearInvestigation,
      selectedInvestigationId,
      setSelectedInvestigationId: updateInvestigationId
    }),
    [
      collapsed,
      setCollapsed,
      setShowDrawer,
      fullScreen,
      setFullScreen,
      clearInvestigation,
      selectedInvestigationId,
      updateInvestigationId
    ]
  );
  return /* @__PURE__ */ React.createElement(InvestigationDrawerContext.Provider, { value: contextValue }, !isRightSidebarEnabled && showDrawer && /* @__PURE__ */ React.createElement(InvestigationDrawer, null), children);
}
export const useInvestigationDrawer = singleton(
  "security.useInvestigationDrawer",
  () => () => useContext(InvestigationDrawerContext)
);
